module.exports = __webpack_public_path__ + "img/user-profile.5953a2a5.png";